import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  ThemeProvider,
  Typography,
} from "@mui/material";

import { MuiTheme } from "../styles/MuiDataTableStyle";
import Reports from "./reports";
import { useStateReportValue } from "../context/Reports";
import { element } from "prop-types";
import encode from "jwt-encode";
import { useLocation } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { getAllReports } from "../services/reportsService";
import { useStateAuthValue } from "../context/AuthState";
import { showToast, ToastType } from "../utils/ToastUtil";
import { useToast } from "../context/Toast/ToastProvider";
import GenericDashboard from "./genericDashboard";

const ConsultasDashboard = () => {
  const [isShowingDashboard, setisShowingDashboard] = useState(true);
  //const [{ reports }] = useStateReportValue();
  const [reports, setReports] = useState([]);
  const [url, setUrl] = useState("");
  const [currentView, setcurrentView] = useState(null);
  const [{ userToken }] = useStateAuthValue();
  const toastDispatch = useToast();

  const embeber = (token, dashboard) => {
    const payload = {
      resource: { dashboard: dashboard },
      params: {},
      exp: Math.round(Date.now() / 1000) + 6000, // 10 minutos de expiración
    };
    const tokenJWT = encode(payload, token);
    const url =
      process.env.REACT_APP_API_URL +
      `/embed/dashboard/${tokenJWT}#bordered=true&titled=true`;
    return url;
  };
  const displayError = (msg) =>
    showToast(toastDispatch, msg, ToastType.ERROR, ToastType.ERROR);
  useEffect(() => {
    getReports();
    GetLocation();
  }, []);
  const getReports = async () => {
    let reportsGet = await getAllReports(userToken, displayError);
    console.log(reportsGet);

    setReports(reportsGet);
  };
  const GetLocation = () => {
    const urlParams = new URLSearchParams(window.location.search);

    // Obtener el valor del parámetro "param"
    const paramValue = urlParams.get("param");

    setcurrentView(paramValue);
    if (paramValue) {
      let report = reports.find((element) => element.name === paramValue);
      if (!report) {
        const url = new URL(window.location);
        url.search = "";
        window.history.pushState({}, "", url);
      } else {
        setUrl(embeber(report?.secrey_key, parseInt(report?.remote_id, 10)));
      }
    }
  };
  const miRef = useRef(null);

  const centrarComponente = () => {
    miRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  };
  const handleChangeView = (viewName) => {
    setisShowingDashboard(false);
    // Crear una instancia del objeto URL basado en la URL actual
    const url = new URL(window.location);

    // Agregar o actualizar el parámetro
    url.searchParams.set("param", viewName);

    // Actualizar la URL en el navegador sin recargar la página
    window.history.pushState({}, "", url);

    let report = reports?.find((element) => element.name === viewName);
    if (report) {
      GetLocation();
      setUrl(embeber(report.secrey_key, parseInt(report.remote_id, 10)));
      setTimeout(() => {
        centrarComponente();
      }, 100);
    } else {
      // Eliminar todos los parámetros de la URL
      url.search = "";

      // Reemplazar la URL en el navegador sin recargar la página
      window.history.replaceState({}, "", url);
    }
  };
  const buttonsList = [
    { label: "Consultas", reportName: "Consultas" },
    { label: "Recetas x periodo", reportName: "Recetas Emitidas Periodo" },
    { label: "Datos por Año", reportName: "Datos Del Año" },
  ];
  return (
    <GenericDashboard
      title={"Reportes consultas"}
      buttonsList={buttonsList}
    />
  );
};

export default ConsultasDashboard;
